import { formatInstant, resolveDisplayZone } from "@checklist/shared";

/** Suggested checklist name: source name plus the viewer's current month and year. */
export function suggestedChecklistName(templateName: string): string {
  const now = new Date();
  const monthYear = formatInstant(now, resolveDisplayZone(), {
    format: "monthYear",
    locale: "en-US",
  });
  const base = templateName.trim() || "Checklist";
  return `${base} — ${monthYear}`;
}
